<template>
    <div class="main">
        <div style="font-size: 0;">
            <img class="brand-img" v-for="imgItem,imgIndex in urlList" :key="imgIndex" :src="imgItem" alt=""
                @click="viewImg(imgIndex)">
            <div v-if="type==1" class="text-box font28">
                <div v-for="item,index in introduceText" :key="index">{{item}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
    name: 'brandDetail',
    components: {
        ImagePreview
    },
    data() {
        return {
            type: 0,
            introduceText: [
                '美丽田园（Beauty Farm）作为美丽田园医疗健康产业有限公司的旗舰品牌，于1993年成立，是中国美丽与健康管理服务行业中成立已久的国内知名连锁品牌之一。',
                '30年不断深耕，从美丽田园创立之初就开始引进国际美容理念，并使用先进的护理技术、产品仪器、质控流程、服务标准，为每位客人带来舒适的美容美体护理服务。随着国内科技水平的飞速跃进，我们也开始与业内第一梯队的生物科技公司携手共创美容新技术。',
                '我们致力于美与健康的发展，持续科技革新，坚守品牌价值，坚持系统化标准化管理和美与健康一站式服务，为顾客提供舒适的美与健康新体验。',
                '2023年1月16日，美丽田园医疗健康产业有限公司作为中国最大的（按2021年收益计）传统美容服务提供商，成功登录香港联合交易所有限公司主板（股份代号：2373.HK），在创立30周年之际开启崭新历程。'
            ],
            urlList: []
        }
    },
    mounted() {
        this.type = this.$route.query.type
        switch (this.type) {
            case 1:
                document.title = '品牌介绍'
                this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/detail-1.png']
                break
            case 2:
                document.title = '品牌历程'
                this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/history.jpg']
                break
            case 3:
                document.title = '品牌荣誉'
                this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/honor.jpg']
                break
            case 4:
                document.title = '品牌服务'
                this.urlList = [
                    'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/service1.jpg',
                    'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/service2.jpg',
                    'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/service3.jpg',
                    'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/service4.jpg',
                ]
                break
            case 5:
                document.title = '门店环境'
                break
            case 6:
                document.title = '企业文化'
                this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/culture.jpg']
                break
        }
    },
    methods: {
        viewImg(index) {
            ImagePreview([this.urlList[index]])
        }
    }
}
</script>

<style scoped>
.main {
    height: 100%;
    width: 750px;
    background: #fff;
    overflow-y: auto;
}
.brand-img {
    width: 100%;
    height: auto;
}
.text-box {
    padding: 40px 40px 0 30px;
    color: #35434c;
    letter-spacing: 1px;
    line-height: 42px;
}
img {
    margin: 0;
    padding: 0;
}
</style>